import React, { Component } from 'react'
import { get, isEmpty } from 'lodash'
import { PropTypes } from 'prop-types'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import { Checkbox, Select } from 'components/fields'
import { compose } from 'recompose'
import { form } from '../../../helpers/decorators'
import { apiTranslations } from '../../../helpers/decorators/api'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import styles from './configuration-email-set-modal.styl'
import { RichTextArea } from '../../richtext'
import { modal } from '../../../redux/modules/app'

const enhance = compose(
    apiTranslations(),
    connect(state => ({
          translations: state.api.translations,
          localeId: state.app.locale.id
        }),
        {
          modal
        }
    )
)

class ConfigurationTTSetModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    onUpdateConfigKeyBulk: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    isConfigUpdating: PropTypes.bool,
    dropdownLocales: PropTypes.array,
    common: PropTypes.object,
    onLoadTranslations: PropTypes.func,
    onLoadDefaultTranslations: PropTypes.func,
    translations: PropTypes.object,
    localeId: PropTypes.number,
    bulkSetResult: PropTypes.func
  }

  static defaultProps = {
    data: {}
  }

  state = {
    propagateToAllLangsChecked: false,
    localeId: this.props.localeId,
    defaultLocaleId: this.props.localeId,
    showDefaultText: false
  }

  componentWillReceiveProps = async (nextProps = {}) => {
    const { data } = this.props

    // On modal open, initialize the form with default locale 2 (= English)
    if (isEmpty(data) && (get(data, 'configurationKey.keyName.value') !== get(nextProps, 'data.configurationKey.keyName.value'))) {
      const data = get(nextProps, 'data.translationKey')
      data && this.props.onLoadTranslations([data], 2)
    }

    if (get(this.props, 'data.organization') !== get(nextProps, 'data.organization')) {
      this.props.change('organization', get(nextProps, 'emailContentCfg.organization'))
    }

    if (get(data, 'configurationKey.keyName.value') !== get(nextProps, 'data.configurationKey.keyName.value')) {
      await this.initForm(nextProps)

      const defaultContentTranslationKey = get(nextProps, 'data.defaultTranslationKey')

      defaultContentTranslationKey && this.props.onLoadDefaultTranslations([defaultContentTranslationKey], 2)

      await this.reload(this.props.localeId)
    }

    const translationsData = get(this.props.translations, 'data')

    const oldContentText = this.findTranslation(translationsData, data, 'translationKey')

    const newTranslationsData = get(nextProps, 'translations.data')

    const newContentText = this.findTranslation(newTranslationsData, data, 'translationKey')

    if (oldContentText !== newContentText) {
      this.props.change('content', newContentText)
    }
  }

  initForm = props => {
    const initObj = {
      content: get(props, 'data.translatedText'),
      organization: get(props, 'data.organization'),
      id: get(props, 'data.id')
    }

    this.props.initialize(initObj)
  }

  setStateToDefault = () => {
    this.setState({
      showDefaultText: false,
      localeId: this.props.localeId,
      defaultLocaleId: 2
    })

    this.reload(this.props.localeId)
    this.initForm(this.props)
  }

  reload = localeId => {

    const data = get(this.props.data, 'translationKey')

    data && this.props.onLoadTranslations([data], localeId)
  }

  handleRequestClose = () => {
    this.setStateToDefault()
    this.props.modal(null)
  }

  handleUpdateKey = async fields => {
    const { data } = this.props

    const configOptionsMap = {}

    if (!fields.localeId) {
      fields.localeId = this.state.localeId
    }

    configOptionsMap[get(data, 'configurationKey.keyName.value')] = {
      type: get(data, 'configurationKey.valueType'),
      id: get(data, 'id'),
      fieldName: 'content',
      translationKey: get(data, 'translationKey'),
      orgId: get(data, 'organization.id')
    }


    this.props.onUpdateConfigKeyBulk(fields, { configOptionsMap })
        .then(data => {
          this.props.bulkSetResult(data.body)
          this.setStateToDefault()
          this.props.modal('bulk-config-update-modal')
        }
    )
  }

  handleLanguageChange = async(obj = {}) => {

    const data = get(this.props.data, 'translationKey')

    await this.props.onLoadTranslations([data], obj.value)
    this.setState({ localeId: obj.value })
  }

  handleCheck = () => {
    this.setState({ propagateToAllLangsChecked: !this.state.propagateToAllLangsChecked })
  }

  findTranslation = (data, cfg, attribName) => {
    const translationKey = get(cfg, attribName)

    const translation = translationKey && data.find(i => i.translationKey === translationKey)

    return translation ? translation.text : ''
  }

  switchTextMsg = () => {
    this.setState({ showDefaultText: !this.state.showDefaultText })
  }

  render() {
    const { modalId, data, handleSubmit, isConfigUpdating, dropdownLocales, common, translations } = this.props

    const defaultData = get(translations, 'default')

    const contentDefaultTranslation = this.findTranslation(defaultData, data, 'defaultTranslationKey')

    return (
      <Modal id={modalId} customActions enableOverflow noEscape>
        <Title h2 >{get(data, 'configurationKey.translatedDescription')}</Title>
        <form onSubmit={handleSubmit(this.handleUpdateKey)}>

          <div className={styles.languagePanel}>
          <div className={styles.langs}>
            <Select
              label="Language"
              intlKey="label.language"
              name="localeId"
              options={dropdownLocales}
              searchable
              loading={common.loading}
              disabled={this.state.propagateToAllLangsChecked || this.state.showDefaultText}
              onSelectChange={this.handleLanguageChange}
              value={this.state.localeId}
          />
          </div>
            <div className={styles.langOptions}>
          <Checkbox
              label="Apply to all languages"
              intlKey="label.aply_to_all_langs"
              name="propagateToAllLangs"
              onChange={this.handleCheck}
              disabled={this.state.showDefaultText}
          />
            </div>
          </div>

          <div className={styles.emailPanel}>

            <div className={this.state.showDefaultText ? styles.defaultTranslation : styles.defaultTranslationDisabled}>
              <Title h3 intl="moduleTitle.email_original_textation">
                Original (English UK) textation
              </Title>
            </div>

          <div>

            <div className={this.state.showDefaultText ? styles.translationDisabled : styles.translation}>
          <RichTextArea label="Text"  intlKey="label.email_text" name="content" isInitialized={true}/>
            </div>

            <div className={this.state.showDefaultText ? styles.defaultTranslation : styles.defaultTranslationDisabled}>
            <span>
              <FormattedMessage
                  id="label.email_original_text"
                  defaultMessage='Text'
              />
            </span>
              <div className={styles.defaultTranslationText}>
              <p>
                <FormattedHTMLMessage id="email_original_empty_text" defaultMessage={contentDefaultTranslation} />
              </p>
              </div>
            </div>
          </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className={styles.buttonGroup}>
                <Button
                  type="button"
                  secondary
                  intlKey="button.close"
                  onClick={this.handleRequestClose}
                >
                  Close
                </Button>
                <Button
                    secondary
                    type="button"
                    intlKey={this.state.showDefaultText ? 'button.switch_to_custom' : 'button.switch_to_default'}
                    onClick={() => this.switchTextMsg()}
                >
                  {this.state.showDefaultText ? 'Show Customization' : 'Show Original'}
                </Button>
              </div>
            </div>
            <div style={{ textAlign: 'right', width: '98%' }}>
              <Button
                intlKey="button.update"
                isLoading={isConfigUpdating}
                disabled={isConfigUpdating || this.state.showDefaultText}
              >
                Update
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default enhance(ConfigurationTTSetModal)
